export default {
      id: "all-givings-card-usage",
      viewBox: "0 0 43 44",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#all-givings-card",
      toString: function () {
        return this.url;
      }
    }